import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { AvatarComponent } from '../../components/avatar/avatar.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { TranslatePipe } from '../../filters/translate.pipe';
import ServiceRestServices from '../../services/service-rest.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import RoutingService from '../../services/routing.service';
import Session from '../../utils/session.service';

@Component({
	standalone: true,
	selector: 'chatbot-introduction',
	templateUrl: './chatbot-introduction.component.html',
	styleUrl: './chatbot-introduction.component.scss',
	imports: [CommonModule, AvatarComponent, LoaderOverlayComponent, TranslatePipe]
})
export default class ChatBotIntroductionView implements OnInit {
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	private session: Session = inject(Session);

	vm: any = undefined;

	constructor() {
		this.vm = this;
	}

	ngOnInit() {
		this.routingService.validateAccess('booking').then(() => {
			this.loadService();
		});
	}

	loadService() {
		this.vm.loading = true;
		this.vm.serviceId = this.angularRoutingHelperService.getRouteParam('serviceId');
		this.vm.user = this.session.getSession().user;
		this.vm.origin = this.vm.user.origin;
		this.vm.buttonTheme = this.vm.origin === 'siffi.com' ? 'c-button--s2' : 'c-button--s1';

		this.serviceRestServices.getServiceById({ id: this.vm.serviceId },
			(service) => {
				if (!service || !service.chatBot) {
					this.vm.loadFailed = true;
					this.vm.loading = false;
					return;
				}
				this.vm.service = service;
				this.vm.loading = false;
			},
			() => {
				this.vm.loadFailed = true;
				this.vm.loading = false;
			}
		);
	}

	goBack(event) {
		if (event && event.preventDefault) {
			event.preventDefault();
		}
		history.back();
	}

	startChat() {
		if (this.vm.starting || !this.vm.service || !this.vm.service.user) {
			return;
		}
		this.vm.starting = true;
		this.serviceRestServices.startChatBot({ serviceUserId: this.vm.service.user.id },
			(lastChatPost) => {
				var chat: any = lastChatPost && lastChatPost.chat;
				if (chat && chat.id) {
					this.angularRoutingHelperService.setPath(['/chats', chat.id]);
				} else {
					this.vm.startFailed = true;
					this.vm.starting = false;
				}
			},
			() => {
				this.vm.startFailed = true;
				this.vm.starting = false;
			}
		);
	}
}
